import React, { useEffect, useState } from "react";
import { Dialog } from "@mui/material";

/// Engelleme sebebi penceresi. Sebep yazilmadan engellenemez;
/// engeli kaldirmada sebep sorulmaz, yalnizca onay alinir.
/// Kullanim: <BlockReason row={secili} onClose={...} onConfirm={(sebep)=>...} />
const PRESETS = [
  "Uygunsuz içerik",
  "Taciz / hakaret",
  "Sahte hesap",
  "Dolandırıcılık",
  "Yaş sınırı ihlali",
  "Spam / reklam",
];

const BlockReason = ({ row, onClose, onConfirm }) => {
  const [reason, setReason] = useState("");
  const open = !!row;
  const unblocking = !!row?.isBlock;

  useEffect(() => {
    if (open) setReason("");
  }, [open, row?._id]);

  if (!open) return null;

  const ok = unblocking || reason.trim().length >= 3;
  const S = styles;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" PaperProps={{ style: S.paper }}>
      <div style={S.head}>
        <div>
          <div style={S.title}>{unblocking ? "Engeli kaldır" : "Engelle"}</div>
          <div style={S.sub}>{row?.name}</div>
        </div>
        <button type="button" style={S.close} onClick={onClose} aria-label="Kapat">
          ×
        </button>
      </div>

      <div style={S.body}>
        {unblocking ? (
          <>
            <p style={S.text}>
              <b>{row?.name}</b> üzerindeki engel kaldırılacak. Tekrar giriş yapıp yayın açabilecek.
            </p>
            {row?.blockReason && <div style={S.oldReason}>Engel sebebi: {row.blockReason}</div>}
          </>
        ) : (
          <>
            <label style={S.label}>Engelleme sebebi</label>
            <textarea
              style={S.input}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Neden engelleniyor? Bu kayıt saklanır."
              maxLength={300}
              autoFocus
            />
            <div style={S.presets}>
              {PRESETS.map((p) => (
                <button key={p} type="button" style={S.chip} onClick={() => setReason(p)}>
                  {p}
                </button>
              ))}
            </div>
            <div style={S.hint}>En az 3 karakter. Sebep yazmadan engelleyemezsin.</div>
          </>
        )}
      </div>

      <div style={S.foot}>
        <button type="button" style={{ ...S.btn, ...S.btnGhost }} onClick={onClose}>
          Vazgeç
        </button>
        <button
          type="button"
          disabled={!ok}
          style={{ ...S.btn, ...(unblocking ? S.btnGreen : S.btnRed), ...(ok ? {} : S.btnOff) }}
          onClick={() => onConfirm(reason.trim())}
        >
          {unblocking ? "Engeli kaldır" : "Engelle"}
        </button>
      </div>
    </Dialog>
  );
};

const styles = {
  paper: { borderRadius: 16, background: "#fff" },
  head: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "20px 22px 12px",
    borderBottom: "1px solid #eef1f6",
    background: "#fff",
  },
  title: { fontSize: 18, fontWeight: 700, color: "#1b2334" },
  sub: { fontSize: 13, color: "#8b93a7", marginTop: 2 },
  close: {
    border: "none",
    background: "#f2f4f8",
    color: "#5b6478",
    width: 32,
    height: 32,
    borderRadius: 8,
    fontSize: 20,
    lineHeight: "20px",
    cursor: "pointer",
  },
  body: { padding: "18px 22px", background: "#fff" },
  text: { fontSize: 14.5, color: "#42506b", lineHeight: 1.6, margin: 0 },
  oldReason: {
    marginTop: 12,
    fontSize: 13,
    color: "#b42318",
    background: "#fff5f5",
    borderRadius: 8,
    padding: "8px 12px",
  },
  label: { display: "block", fontSize: 12.5, fontWeight: 600, color: "#42506b", marginBottom: 6 },
  input: {
    width: "100%",
    height: 84,
    resize: "vertical",
    border: "1px solid #dde2ec",
    borderRadius: 10,
    padding: "10px 12px",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
  },
  presets: { display: "flex", flexWrap: "wrap", gap: 6, marginTop: 10 },
  chip: {
    border: "1px solid #dde2ec",
    background: "#fff",
    color: "#42506b",
    borderRadius: 999,
    padding: "5px 12px",
    fontSize: 12.5,
    fontWeight: 600,
    cursor: "pointer",
  },
  hint: { fontSize: 12, color: "#8b93a7", marginTop: 10 },
  foot: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    padding: "14px 22px 20px",
    borderTop: "1px solid #eef1f6",
    background: "#fff",
  },
  btn: {
    border: "1px solid transparent",
    borderRadius: 10,
    padding: "9px 20px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
  },
  btnGhost: { background: "#fff", borderColor: "#dde2ec", color: "#42506b" },
  btnRed: { background: "#f04438", color: "#fff" },
  btnGreen: { background: "#12b76a", color: "#fff" },
  btnOff: { opacity: 0.45, cursor: "not-allowed" },
};

export default BlockReason;
